export class StringHelper {

    // Debe coincidir con AutoserviceCodeSlug.MaxLength del backend
    private static readonly SLUG_MAX_LENGTH = 40;

    /**
     * Normaliza un nombre a un slug de un solo sentido: minúsculas, sin diacríticos,
     * separadores colapsados en un único '-', sin '-' al inicio/fin, cortado a
     * SLUG_MAX_LENGTH caracteres y sin '-' al final tras el corte. Debe coincidir
     * exactamente con AutoserviceCodeSlug.Normalize del backend (posmaerapidev) para
     * que la resolución de la URL de autoservicio por slug nunca diverja (issue #357).
     */
    static slugify(name: string): string {
        if (!name || !name.trim()) return '';

        let slug = name
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '');

        slug = slug.replace(/\s+/g, '-');
        slug = slug.replace(/[^a-z0-9-]/g, '');
        slug = slug.replace(/-+/g, '-').replace(/^-+|-+$/g, '');

        if (slug.length > StringHelper.SLUG_MAX_LENGTH) {
            slug = slug.substring(0, StringHelper.SLUG_MAX_LENGTH).replace(/-+$/g, '');
        }

        return slug;
    }

    static b64toBlob(b64Data, contentType = '', sliceSize = 512): Blob {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
}
